"use client";
import React from "react";
import {
  Box,
  Center,
  Divider,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  VStack,
  Text,
  Flex,
  SimpleGrid,
} from "@chakra-ui/react";
import {COLOCATION_DATA, COLOCATION_FOOTER_CONSTANTS} from "./constants"; // your colocations array
import {useSectionHeadingVariant} from "@/theme/components/useSectionHeading";
import PricingFooter from "@/components/pricingFooter";

// Desktop Table View
export const DesktopView = () => {
  return (
    <TableContainer>
      <Table variant="striped" border={"2px solid rgb(237,242,247)"} width={"100%"}>
        <Thead>
          <Tr>
            <Th>Type</Th>
            <Th>Rack Space</Th>
            <Th>Power</Th>
            <Th>Free Remote Hands</Th>
            <Th>Location</Th>
            <Th>Contract Length</Th>
            <Th>Price / Month</Th>
          </Tr>
        </Thead>
        <Tbody>
          {COLOCATION_DATA.map((colo, index) => (
            <Tr key={index} fontSize={"15px"} color="#2d3748">
              <Td>{colo.type}</Td>
              <Td>{colo.rackSpace}</Td>
              <Td>{colo.power}</Td>
              <Td>{colo.remoteHands}</Td>
              <Td>{colo.location}</Td>
              <Td>{colo.contractLength}</Td>
              <Td>
                <Text fontWeight={"700"} fontSize={"18px"} color="blue.600">
                  {colo.price}
                </Text>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

// Mobile Card View
export const MobileView = () => {
  return (
    <SimpleGrid columns={{base: 1, sm: 2}} spacing={6}>
      {COLOCATION_DATA.map((colo, index) => (
        <VStack
          key={index}
          borderRadius="lg"
          borderWidth="1px"
          borderColor="gray.200"
          boxShadow="md"
          spacing={4}
          w="100%"
          p={4}
          bg="white"
        >
          <Text fontWeight="bold" fontSize="xl" color="blue.600">
            {colo.type}
          </Text>

          <Divider borderColor="gray.200" />

          <Flex direction="column" w="full">
            <Text fontSize="sm" color="text.100">
              Rack Space
            </Text>
            <Text fontWeight="medium" fontSize="md">
              {colo.rackSpace}
            </Text>
          </Flex>

          <Flex direction="column" w="full">
            <Text fontSize="sm" color="text.100">
              Power
            </Text>
            <Text fontWeight="medium" fontSize="md">
              {colo.power}
            </Text>
          </Flex>

          <Flex direction="column" w="full">
            <Text fontSize="sm" color="text.100">
              Free Remote Hands
            </Text>
            <Text fontWeight="medium" fontSize="md">
              {colo.remoteHands}
            </Text>
          </Flex>

          <Flex direction="column" w="full">
            <Text fontSize="sm" color="text.100">
              Location
            </Text>
            <Text fontWeight="medium" fontSize="md">
              {colo.location}
            </Text>
          </Flex>

          <Flex direction="column" w="full">
            <Text fontSize="sm" color="text.100">
              Contract Length
            </Text>
            <Text fontWeight="medium" fontSize="md">
              {colo.contractLength}
            </Text>
          </Flex>

          <Flex direction="column" w="full">
            <Text fontSize="sm" color="text.100">
              Price / Month
            </Text>
            <Text fontWeight="bold" fontSize="lg" color="blue.600">
              {colo.price}
            </Text>
          </Flex>
        </VStack>
      ))}
    </SimpleGrid>
  );
};

// Combined Component
const ColocationTable = () => {
  const HeadingVariant = useSectionHeadingVariant();
  return (
    <Box id="colocation">
      <Heading variant={HeadingVariant} textAlign="center" mb={8}>
        Colocation Plans
      </Heading>
      <Center display={{md: "none"}} w="full">
        <MobileView />
      </Center>
      <Box display={{base: "none", md: "block"}}>
        <DesktopView />
      </Box>
      <PricingFooter {...COLOCATION_FOOTER_CONSTANTS} />
      <Divider borderWidth="2px" borderColor="#ECECEC" my={10} />
    </Box>
  );
};

export default ColocationTable;
